var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankDetailsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 27,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 27,
    rx: 3.5,
    stroke: "#E4E4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6668 18.6667V20.6667H11.3335V18.6667C11.3335 18.3 11.6335 18 12.0002 18H24.0002C24.3668 18 24.6668 18.3 24.6668 18.6667Z",
    fill: "#023A66",
    stroke: "#023A66",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.3332 13.3333H12.6665V18H15.3332V13.3333Z",
    fill: "#023A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0002 13.3333H15.3335V18H18.0002V13.3333Z",
    fill: "#023A66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.6667 13.3333H18V18H20.6667V13.3333Z",
    fill: "#023A66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.3332 13.3333H20.6665V18H23.3332V13.3333Z",
    fill: "#023A66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 21.1667H10.6665C10.3932 21.1667 10.1665 20.94 10.1665 20.6667C10.1665 20.3934 10.3932 20.1667 10.6665 20.1667H25.3332C25.6065 20.1667 25.8332 20.3934 25.8332 20.6667C25.8332 20.94 25.6065 21.1667 25.3332 21.1667Z",
    fill: "#023A66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2468 9.83336L18.2468 7.43337C18.1135 7.38004 17.8868 7.38004 17.7535 7.43337L11.7535 9.83336C11.5202 9.92669 11.3335 10.2 11.3335 10.4534V12.6667C11.3335 13.0334 11.6335 13.3334 12.0002 13.3334H24.0002C24.3668 13.3334 24.6668 13.0334 24.6668 12.6667V10.4534C24.6668 10.2 24.4802 9.92669 24.2468 9.83336ZM18.0002 11.6667C17.4468 11.6667 17.0002 11.22 17.0002 10.6667C17.0002 10.1134 17.4468 9.66669 18.0002 9.66669C18.5535 9.66669 19.0002 10.1134 19.0002 10.6667C19.0002 11.22 18.5535 11.6667 18.0002 11.6667Z",
    fill: "#023A66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailsIcon);
export default __webpack_public_path__ + "static/media/bank-details-icon.560502e789ce710979181f9075b32c5a.svg";
export { ForwardRef as ReactComponent };